import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data);
        navigate("/", { replace: true, state: { user: res.data } });
      })
      .catch(() => navigate("/auth", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="auth-callback">
      <div className="flex items-center gap-4">
        <Loader2 className="h-5 w-5 animate-spin text-zinc-100" />
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-400">Connexion…</p>
      </div>
    </div>
  );
}
